// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607071059/js/" + chunkId + "." + {"44":"636368b0","225":"c99db2d6","481":"a538bd13","486":"8dd033b8","770":"0701185f"}[chunkId] + ".0.20703374822897747.chunk.js";
};